/* @flow */
import type {
    PersonalisationLookingForHelpPage,
} from "@/flow/personalisation-page"

export default ({
    type: "who-is-looking-for-help",
    name: "who-is-looking-for-help",
    title: "Who is looking for help?",
    noQuestionStepperBreadcrumb: true,
    getShouldShowInSummary: () => false,
}: PersonalisationLookingForHelpPage)
